export default __webpack_public_path__ + "static/media/form_background.f4bec1b9.jpg";